.card {
    cursor: pointer;
}

.card[data-disabled] {
    cursor: default;
}

.card[data-selected] {
    border-color: var(--mantine-color-blue-6);
    border-width: 2px;
}
